import React, { useCallback, useEffect } from 'react';
import { Theme } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';

import { Button } from '../../../../components/index';
import { CheckIcon } from '../../../../components/icon/solid';
import keyCodeConverter from '../../../../utility/keyCodeConverter';

const useStyles = makeStyles(({ palette }: Theme) => createStyles({
  root: {
    '&:hover': {
      backgroundColor: palette.buttonAction.background,
    },
  },
  disabled: palette.disabledButton,
  buttonIcon: {
    width: '18px',
    height: '18px',
  },
  buttonText: {
    fontFamily: 'Montserrat',
    fontSize: '16px',
    fontWeight: 600,
    letterSpacing: '0.21px',
    textTransform: 'none',
    paddingLeft: '0.25em',
    lineHeight: 'initial',
  },
  panelButton: {
    height: '36px',
    minWidth: '128px',
  },
}), { name: 'ArticleFormSubmit' });

type Props = {
  submit: () => void;
  isValid: boolean;
};

const FormSubmit = ({ submit, isValid }: Props) => {
  const classes = useStyles();

  const submitHandler = useCallback((e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    submit();
  }, [submit]);

  useEffect(() => {
    const save = (event: KeyboardEvent) => {
      if (event.ctrlKey && event.keyCode === keyCodeConverter('s') && isValid) {
        event.preventDefault();
        submit();
      }
    };
    window.addEventListener('keydown', save);
    return () => {
      window.removeEventListener('keydown', save);
    }
  }, [isValid, submit]);

  return (
    <Button
      onClick={submitHandler}
      disabled={!isValid}
      variant="contained"
      color="primary"
      classes={{
        root: classes.root,
        disabled: classes.disabled,
      }}
      className={classes.panelButton}
    >
      <CheckIcon className={classes.buttonIcon} />
      <span className={classes.buttonText}>Save</span>
    </Button>
  );
};

export default FormSubmit;
